<template>
  <div>
    <button class="btn btn-secondary" @click="openOffcanvas" v-if="mostrarBoton">
      <i class="mdi mdi-cog-outline font-size-16"></i>
      Widgets visibles
    </button>

    <div
      style="width: 297px; background-color: #fff; border-left: none !important; box-shadow: -2px 0 12px rgba(0, 0, 0, 0.1) !important;"
      class="offcanvas offcanvas-end h-100" tabindex="-1" id="widgetsVisiblesTableroVpn"
      aria-labelledby="widgetsVisiblesLabel"
    >
      <div class="offcanvas-header p-3 bg-dark">
        <h5 class="m-0 me-0 offcanvas-title d-flex align-items-center text-white" id="widgetsVisiblesLabel">
          Widgets visibles
        </h5>
        <button
          style="width: 28px; height: 28px; background-color: rgba(255, 255, 255, 0.1); color: white; border: none;"
          type="button" class="btn ms-auto d-flex align-items-center justify-content-center rounded-circle p-0"
          data-bs-dismiss="offcanvas" aria-label="Cerrar"
        >
          <i class="mdi mdi-close noti-icon" style="font-size: 16px;"></i>
        </button>
      </div>

      <div class="offcanvas-body p-3">
        <p class="text-muted mb-4">
          Activa o desactiva los widgets que quieres ver en tu tablero.
        </p>

        <div v-for="(visible, widget) in widgets" :key="widget">
          <div class="form-check form-switch form-switch-md" v-if="tienePermiso(nombre_widgets[widget],'componente')">
            <input
              class="form-check-input me-2"
              type="checkbox" :id="`chk-${widget}`"
              :checked="widgets[widget]"
              @change="
                widgets[widget] = !widgets[widget],
                actualizarAjustes(widget)
              "
            />
            <label class="form-check-label" :for="`chk-${widget}`">
              {{ widget.replace('W', '').replace(/([A-Z])/g, ' $1').trim() }}
            </label>
          </div>
        </div>

        <br>

        <button class="btn btn-success w-100 mt-4" @click="actualizarAjustes()">
          <i class="mdi mdi-content-save"></i>
          Guardar cambios
        </button>
      </div>
    </div>
  </div>
</template>
  
<script>
import UsuarioSrv from '@/services/UsuarioSrv.js'
import { todoGetters } from '@/state/helpers'
import Offcanvas from 'bootstrap/js/dist/offcanvas'

export default {
  name: 'WidgetsVisibles',
  data() {
    return {
      widgets: {
        WCredenciales: true
      },

      nombre_widgets: {
        WCredenciales: 'cmpCredenciales',
      }
    }
  },
  computed: { 
    ...todoGetters,
    mostrarBoton: function() {
      var self = this
      var n = 0

      for (var key in self.widgets) {
        if(self.tienePermiso(self.nombre_widgets[key],'componente')) n += 1
      }

      if (n == 0 ) return false
      return true
    }
  },
  methods: {
    actualizarAjustes(widget = 'Todos') {
      var self = this, ajustes = {};

      if (widget === 'Todos') {
        // Recorre todos los widgets y agrega sus valores al objeto ajustes
        for (var [key, value] of Object.entries(self.widgets)) {
          ajustes[key] = value;
        }
      } else if (self.widgets.hasOwnProperty(widget)) {
        // Si es un widget específico, agrega solo ese al objeto ajustes
        ajustes[widget] = self.widgets[widget];
      }

      UsuarioSrv.actualizarAjustes(ajustes).then(response => {
        let mensaje = widget === 'Todos' ? 
              'Todos los ajustes de los widgets se actualizaron correctamente.' : 
              `El ajuste del widget "${widget.replace('W', '').replace(/([A-Z])/g, ' $1').trim()}" se actualizó correctamente.`
        iu.msg.success(mensaje)
        self.cargarAjustesWidgets()

        self.$emit('actualizar-widgets')
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo guardar tema de layoutScrollable'
        }
        console.log(error)
        iu.msg.error(mensaje)
      })
    },
    openOffcanvas: function() {
      var self = this
      var offcanvasEl = document.getElementById('widgetsVisiblesTableroVpn')
      var bsOffcanvas = Offcanvas.getInstance(offcanvasEl)

      if (!bsOffcanvas) {
        bsOffcanvas = new Offcanvas(offcanvasEl, { 
          backdrop: false,
          scroll: true
        })
      }

      if (offcanvasEl.classList.contains('show')) {
        bsOffcanvas.hide()
      } else {
        bsOffcanvas.show()
      }

      self.cargarAjustesWidgets()
    },
    cargarAjustesWidgets: function() {
      var self = this
      var widgets = [ 'cmpCredenciales' ]

      UsuarioSrv.ajustesJSON(widgets).then(response => {
        let ajustes = response.data

        // Convertimos y asignamos cada valor al objeto widgets
        for (var key in ajustes) {
          if (self.widgets.hasOwnProperty(key)) {
            self.widgets[key] = ajustes[key] === '1'; // Convertimos a booleano
          }
        }
      }).catch(error => {
        let mensaje 
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los ajustes del widgets'
        }
        console.log(error)
        iu.msg.error(mensaje)
      })
    }
  }
}
</script>
  
<style scoped>
.form-check-input:checked {
  background-color: #63AD6F;
  border-color: #63AD6F;
}
.offcanvas-no-border {
  border-left: none !important;
  box-shadow: none !important;
}
</style>